import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { NumberInput, Radio, SimplePopover } from '@dev/ee-components';

import { ModifyCampaignMap } from '@/store/campaignCreator/actions';
import { TimeUnitsEnum } from '@/services/dictionaries/TimeUnits';
import { TimeOptions } from '@/services/dictionaries/ScheduleTimeOptions';
import { getTimeInMinutes } from '@/services/tools/getTimeInMinutes';
import { InputsWrapper, RadioOptionWrapper } from '../../styled';
import { useCampaignScreensPathsChecker } from '../../hooks/useCampaignScreensPathsChecker';
import { useGetScheduledInfo } from '../../hooks/useGetScheduleInfo';
import { ScheduleOptionsEnum } from './ScheduledInterface';

const MIN_X_TIMES = 1;

export const SendXTimes = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isDetailsScreen } = useCampaignScreensPathsChecker();
    const { isOneTime, triggerValue, triggerUnit } = useGetScheduledInfo();

    const changeRadioHandle = (ev): void => {
        const is1Time = ev.target.value === 'send1time';
        const modifyMap = new Map<string, any>();

        modifyMap.set('TriggerOptions.SendXTimes', is1Time ? 1 : 0);
        modifyMap.set('TriggerOptions.SendEveryXMinutes', is1Time ? 0 : getTimeInMinutes(triggerValue, triggerUnit));
        dispatch(ModifyCampaignMap(modifyMap));
    };

    const changeNumberInputHandle = (e): void => {
        const value = (e.target ? e.target.value : e.currentTarget.value) || MIN_X_TIMES;
        const modifyMap = new Map<string, any>();
        modifyMap.set('TriggerOptions.SendEveryXMinutes', getTimeInMinutes(value, triggerUnit));
        dispatch(ModifyCampaignMap(modifyMap));
    };

    const itemClickDropdownHandle = (e, obj: { value: TimeUnitsEnum; label: string }): void => {
        const modifyMap = new Map<string, any>();
        modifyMap.set('TriggerOptions.SendEveryXMinutes', getTimeInMinutes(triggerValue, obj.value));
        dispatch(ModifyCampaignMap(modifyMap));
    };

    return (
        <RadioOptionWrapper>
            <Radio
                name="schedule-time-opt"
                gap="4px"
                radios={[
                    {
                        id: 'send1time',
                        label: t('send1time'),
                        value: ScheduleOptionsEnum.Send1time,
                        disabled: isDetailsScreen,
                    },
                    {
                        id: 'sendevery',
                        label: t('sendevery'),
                        value: ScheduleOptionsEnum.SendeveryXTimes,
                        disabled: isDetailsScreen,
                    },
                ]}
                value={isOneTime ? ScheduleOptionsEnum.Send1time : ScheduleOptionsEnum.SendeveryXTimes}
                onChange={changeRadioHandle}
            />
            <InputsWrapper>
                <NumberInput
                    id="numberinput"
                    name="numberinput"
                    min={MIN_X_TIMES}
                    value={triggerValue}
                    onClickButton={changeNumberInputHandle}
                    onChange={changeNumberInputHandle}
                    disabled={isOneTime || isDetailsScreen}
                />
                <SimplePopover
                    type="input"
                    options={TimeOptions}
                    defaultValue={TimeUnitsEnum.Days}
                    value={triggerUnit}
                    minWidth={101}
                    disabled={isOneTime || isDetailsScreen}
                    onItemClick={itemClickDropdownHandle}
                />
            </InputsWrapper>
        </RadioOptionWrapper>
    );
};
